import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AttendanceDisplay } from './AttendanceDisplay';
import { AttendanceUpdate } from './AttendanceUpdate';
import { Four04 } from 'gossamer-front-end';
import { AttendanceCreate } from './AttendanceCreate';

export const AttendanceRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/create/:ticketBookingId" element={<AttendanceCreate />} />
    <Route path="/display/:key" element={<AttendanceDisplay />} />
    <Route path="/update/:key" element={<AttendanceUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
